export const STORAGE_KEYS = ["playlist", "url", "file", "genre", "settings"];
export const TITLES = ["Playlist", "URL", "Files", "Genre", "Settings"];

export const FIELD_MAP = {
    playlist: {
        id: "playlist_type_lookup_id",
        name: "playlist_type_name",
        description: "playlist_type_description",
        status: "status",
        createdAt: "created_at",
    },
    url: {
        id: "url_type_lookup_id",
        name: "url_type_name",
        description: "url_type_description",
        status: "status",
        createdAt: "created_at",
    },
    file: {
        id: "file_type_lookup_id",
        name: "file_type_name",
        description: "file_type_description",
        status: "status",
        createdAt: "created_at",
    },
    genre: {
        id: "genre_type_lookup_id",
        name: "genre_type_name",
        description: "genre_type_description",
        status: "status",
        createdAt: "created_at",
    },
    'difficulty': {
        id: 'difficulty_id',
        name: 'level_name',
        description: 'display_image',
        status: 'status',
        // extraFields: ['bonus_points', 'time_multiplier']
    },
    'question-type': {
        id: 'question_type_id',
        name: 'type_name',
        description: 'display_name',
        status: 'status'
    },
    'answer-type': {
        id: 'answer_type_id',
        name: 'type_name',
        description: 'display_name',
        status: 'status'
    },
    'question-bank': {
        id: 'bank_id',
        name: 'bank_name',
        description: 'bank_name',
        status: 'status'
    }
};